import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  href?: string;
}
export function CTAButton({
  children,
  className = '',
  href = 'https://www.somostrilogy.co/payment-link/69af586984b2d71a3064ccdf'
}: CTAButtonProps) {
  const handleClick = () => {
    const fbq = (window as any).fbq;
    if (typeof fbq === 'function') {
      fbq('track', 'InitiatePayment');
    }
  };
  return <a href={href} onClick={handleClick} className={`inline-block w-full md:w-auto text-center bg-gradient-to-r from-[#F5A623] to-[#FF6B35] text-white font-bold text-lg md:text-xl py-4 px-8 rounded-full shadow-[0_0_20px_rgba(245,166,35,0.4)] hover:shadow-[0_0_30px_rgba(245,166,35,0.6)] hover:scale-105 transition-all duration-300 ${className}`} data-id="element-210">
      {children}
    </a>;
}